import React from 'react';
import { ArrowLeft, Trash2, Mail, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function DataDeletion() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-8">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Volver al inicio
        </Link>
        
        <div className="flex items-center mb-6">
          <Trash2 className="w-8 h-8 text-red-500 mr-3" />
          <h1 className="text-3xl font-bold text-gray-900">Eliminación de Datos</h1>
        </div>
        
        <p className="text-gray-600 mb-8">
          En AI Med Planner respetamos tu privacidad y tu derecho a controlar tus datos personales. 
          Aquí te explicamos cómo solicitar la eliminación de tu información.
        </p>
        
        <div className="space-y-8">
          <section className="bg-blue-50 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
              <Mail className="w-5 h-5 mr-2 text-blue-600" />
              Cómo Solicitar la Eliminación
            </h2>
            <p className="text-gray-700 mb-4">Para solicitar la eliminación de tus datos, envía un correo a:</p>
            <a 
              href="mailto:privacidad@aimedplanner.com?subject=Solicitud de Eliminación de Datos"
              className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition"
            >
              privacidad@aimedplanner.com
            </a>
            <p className="text-gray-600 mt-4 text-sm">
              Incluye en tu correo:
            </p>
            <ul className="list-disc ml-6 mt-2 text-gray-600 text-sm space-y-1">
              <li>Tu nombre completo</li>
              <li>Número de teléfono asociado a tu cuenta</li>
              <li>Correo electrónico de registro</li>
              <li>Motivo de la solicitud (opcional)</li>
            </ul>
          </section>

          <section className="bg-gray-50 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
              <Clock className="w-5 h-5 mr-2 text-gray-600" />
              Proceso y Tiempos
            </h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 mt-0.5">1</span>
                <div>
                  <p className="font-medium text-gray-900">Recepción de solicitud</p>
                  <p className="text-gray-600 text-sm">Confirmaremos tu solicitud en 24-48 horas</p>
                </div>
              </div>
              <div className="flex items-start">
                <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 mt-0.5">2</span>
                <div>
                  <p className="font-medium text-gray-900">Verificación de identidad</p>
                  <p className="text-gray-600 text-sm">Verificaremos que eres el titular de los datos</p>
                </div>
              </div>
              <div className="flex items-start">
                <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 mt-0.5">3</span>
                <div>
                  <p className="font-medium text-gray-900">Eliminación de datos</p>
                  <p className="text-gray-600 text-sm">Tus datos serán eliminados en un máximo de 30 días</p>
                </div>
              </div>
              <div className="flex items-start">
                <span className="bg-green-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 mt-0.5">✓</span>
                <div>
                  <p className="font-medium text-gray-900">Confirmación</p>
                  <p className="text-gray-600 text-sm">Recibirás un correo confirmando la eliminación</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Datos que se Eliminarán</h2>
            <ul className="list-disc ml-6 text-gray-700 space-y-1">
              <li>Información de perfil y contacto</li>
              <li>Historial de conversaciones</li>
              <li>Citas y recordatorios</li>
              <li>Preferencias y configuraciones</li>
            </ul>
          </section>

          <section className="bg-yellow-50 rounded-lg p-6">
            <h2 className="text-lg font-semibold text-yellow-800 mb-2">⚠️ Importante</h2>
            <p className="text-yellow-700 text-sm">
              Algunos datos pueden ser retenidos por obligaciones legales o para prevenir fraude. 
              En tal caso, te informaremos qué datos no pueden ser eliminados y el motivo.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
